import Request from './request'

const ClientOrder  = {
  getOrdersList(callback) {
    Request.get('client-order').then(callback).catch(this.bad_answer)
  },
}

export default ClientOrder
